
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { NavItem } from "./navItems";
import { useEffect } from "react";

interface SidebarNavItemsProps {
  items: NavItem[];
  userRole: string;
}

export function SidebarNavItems({ items, userRole }: SidebarNavItemsProps) {
  const location = useLocation();
  
  useEffect(() => {
    console.log("[SidebarNavItems] Rendering with location:", location.pathname);
    console.log("[SidebarNavItems] User role:", userRole);
  }, [location.pathname, userRole]);
  
  // Filter nav items based on user role
  const filteredNavItems = items.filter(item => {
    if (!item.roles) return true;
    return item.roles.includes(userRole as 'creator' | 'student') || item.roles.includes('any');
  });
  
  useEffect(() => {
    console.log("[SidebarNavItems] Filtered items:", filteredNavItems);
  }, [filteredNavItems]);
  
  return (
    <nav className="space-y-1">
      {filteredNavItems.map((item) => {
        const isActive = location.pathname === item.href || 
                        (item.href !== '/dashboard' && location.pathname.startsWith(item.href));
        
        return (
          <Link key={item.name} to={item.href} className="block">
            <Button
              variant="ghost"
              className={cn(
                "w-full justify-start gap-3 font-normal",
                isActive && "bg-primary/10 text-primary font-medium"
              )}
            >
              {item.icon}
              {item.name}
            </Button>
          </Link>
        );
      })}
    </nav>
  );
}
